import React from 'react'
import {motion} from 'framer-motion'
import edu from '../images/edu.png'
import edu2 from '../images/edu2.jpg'
import Project from './Project'

function Education() {
  return (
    <div className='exp'>
        <motion.h2 
        initial={{opacity: 0, y: 50}}
        whileInView={{opacity: 1, y:0}}
        transition={{type: "just",duration: 0.5}}
        id='heading'>My Education</motion.h2>
        <motion.p
        initial={{opacity: 0, y: 50}}
        whileInView={{opacity: 1, y:0}}
        transition={{type: "just",duration: 0.5}}
        className="caption title para">The journey that has shaped me, empowered me, and transformed me into who I am today.</motion.p>
            <div className='cols'>
                <div className='row_1'>
                    <Project img={edu} title={" University of Maryland"} link={"https://umbc.edu/"} github={false}/>
                    <motion.div 
                    initial={{opacity: 0, x: 100}}
                    whileInView={{opacity: 1, x:0}}
                    transition={{type: "just",duration: 0.5}}
                    className='row_content'>
                        <h2>University of Maryland, Baltimore County</h2>
                        <h4 className='caption'>MSc. Information Systems</h4>
                        <h5 className='caption'>May 2021</h5>
                    </motion.div>
                </div>

                <div className='row_1 row_2'>     
                    <motion.div 
                    initial={{opacity: 0, x: -100}}
                    whileInView={{opacity: 1, x:0}}
                    transition={{type: "just",duration: 0.5}}
                    className='row_content'>
                        <h2>University of Texas</h2>
                        <h4 className='caption'>BA International Management & Minor in Information Systems</h4>
                        <h5 className='caption'>August 2019</h5>
                        
                    </motion.div>
                    <Project img={edu2} title={"University of Texas"} link={"https://www.utexas.edu/"} github={false}/>
                </div>

            </div>
    </div>
  )
}

export default Education